import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/home/index' //首頁
import xwzx from '@/components/home/xwzx'//新闻中心

import index_detail from '@/components/detail/Index_detail'//品质保障详情
import pzbz_detail from '@/components/detail/Pzbz_detail'//品质保障详情
import contact from '@/components/home/contact'//联系我们
// import about from '@/components/home/about'//关于我们

import article_detail from '@/components/detail/Article_detail.vue'//文章详情
import lowversion from '@/components/home/LowVersion.vue'//低版本提示页
Vue.use(Router)

export default new Router({
	mode:'history',
	routes: [
		{
			path:'/',
			redirect:'/index'
		},
		{
			path:'/index',
			name:'index',
			component:index,
			children:[
				{path:'/', component:index}
			]
		},
		{//xwzx
			path: '/xwzx',
			name: 'xwzx',
			component: xwzx,
			children:[
				{path:'/', component:xwzx}
			]
		},
		{//低版本跳转页
			path: '/lowversion',
			name: 'lowversion',
			component: lowversion
		},
		{//首页详情
			path: '/detail/Index_detail',
			component: index_detail,
		},
		{//pzbz详情
			path: '/detail/Pzbz_detail',
			component: pzbz_detail,
		},
		{//联系我们
			path:'/contact',
			name:'contact',
			component:contact
		},
		{//文章详情
			path: '/detail/article_detail',
			component: article_detail,
		},

	]
})
